'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UITooltipContent(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _classNames2.default)('private-tooltip__inner', className),
      role: 'tooltip'
    },
    children
  );
}

UITooltipContent.propTypes = {
  children: _react.PropTypes.node
};

UITooltipContent.displayName = 'UITooltipContent';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tooltip/UITooltipContent.js
// module id = 424
// module chunks = 3 4 5